/* <vehicle-fit-badge> — grünes "Passt ✓" auf Produktkarten im Grid.
   Zeigt sich nur, wenn das im Header gewaehlte Fahrzeug (localStorage-Garage cr-vehicle-v1)
   auf CHASSIS-Ebene zum Produkt passt (Typ enthalten). Selbst-initialisierend -> funktioniert
   auch bei nachgeladenen Karten (Pagination/Quick-Add). Doku: docs/fahrzeug-finder-index.md */
(function () {
  'use strict';
  if (customElements.get('vehicle-fit-badge')) return;

  customElements.define('vehicle-fit-badge', class extends HTMLElement {
    connectedCallback() {
      this.key = this.getAttribute('data-storage-key') || 'cr-vehicle-v1';
      this.pMarke = this._arr('data-p-marke');
      this.pTyp = this._arr('data-p-typ');
      if (!this.pMarke.length) { this.hidden = true; return; }
      this._onStorage = this._onStorage.bind(this);
      window.addEventListener('storage', this._onStorage);
      window.addEventListener('pageshow', this._onStorage);
      this.render();
    }
    disconnectedCallback() {
      window.removeEventListener('storage', this._onStorage);
      window.removeEventListener('pageshow', this._onStorage);
    }
    _onStorage(e) {
      if (e && e.type === 'storage' && e.key && e.key !== this.key) return;
      this.render();
    }
    _arr(attr) {
      try {
        var v = JSON.parse(this.getAttribute(attr) || '[]');
        return Array.isArray(v) ? v.map(function (x) { return String(x); }) : [];
      } catch (_) { return []; }
    }
    _norm(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }
    _has(list, val) {
      if (!val) return false;
      var n = this._norm(val);
      return list.some(function (x) { return this._norm(x) === n; }, this);
    }
    _veh() { try { return JSON.parse(localStorage.getItem(this.key)); } catch (_) { return null; } }
    render() {
      var veh = this._veh();
      // Nur bei bestaetigtem Chassis-Treffer anzeigen (Marke + Typ passen).
      var fit = veh && veh.typ && this._has(this.pMarke, veh.marke) && this._has(this.pTyp, veh.typ);
      this.hidden = !fit;
    }
  });
})();
